import React from 'react';
import { IAuditoriaProvisaoPisCofinsResultado } from '../interfaces/IAuditoriaProvisaoPisCofins';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaProvisaoPisCofinsResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


const AuditoriaResumoProvisaoPisCofins: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = resultado.provisoesAusentes?.length || 0;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Provisão Mensal de PIS/COFINS</h3>
      <p className='text-muted'>
        Meses com faturamento apurado sem nenhum lançamento de provisão de PIS/COFINS no mesmo mês — violação do
        princípio da competência (Lei nº 9.718/1998 e Lei nº 10.833/2003). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Multa ECD Potencial</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_PROVISAO_PIS_COFINS')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Provisão Mensal de PIS/COFINS sobre Faturamento</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} competência{totalOcorrencias === 1 ? '' : 's'} com provisão ausente no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Multa ECD potencial — 5% sobre o faturamento do mês sem provisão, limitada a 1% da receita bruta do período (Art. 12, II, Lei 8.218/91).</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoProvisaoPisCofins;
